import { render } from "./StatItem.vue?vue&type=template&id=593e3954&scoped=true"
import script from "./StatItem.vue?vue&type=script&lang=js"
export * from "./StatItem.vue?vue&type=script&lang=js"

import "./StatItem.vue?vue&type=style&index=0&id=593e3954&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-593e3954"

export default script